import { formatInt } from '../../lib/format.ts'
import { Button } from './Button.tsx'

/**
 * Paginador.
 *
 * Recebe a página e o `pageSize` **que o servidor devolveu**, não os que a tela
 * pediu: o servidor grampeia o tamanho em 200 silenciosamente, e calcular o
 * intervalo com o valor enviado faz a última página sumir da conta.
 *
 * Só anterior/próxima, sem os números das páginas: a navegação real destas
 * telas é a busca e o filtro. Uma régua de páginas convida a procurar linha por
 * linha, que é o pior jeito de achar uma empresa entre 137.
 */
export function Pagination({
  page,
  pageSize,
  totalCount,
  totalPages,
  busy = false,
  onPageChange,
}: {
  page: number
  pageSize: number
  totalCount: number
  totalPages: number
  busy?: boolean
  onPageChange: (page: number) => void
}) {
  const first = totalCount === 0 ? 0 : (page - 1) * pageSize + 1
  const last = Math.min(page * pageSize, totalCount)

  return (
    <nav
      aria-label="Paginação"
      className="flex shrink-0 flex-wrap items-center gap-x-3 gap-y-1 border-t border-line-subtle px-3 py-1.5 text-micro text-fg-muted"
    >
      <span>
        <span className="tnum text-fg-secondary">
          {formatInt(first)}–{formatInt(last)}
        </span>{' '}
        de <span className="tnum text-fg-secondary">{formatInt(totalCount)}</span>
      </span>

      <span className="ml-auto">
        página <span className="tnum text-fg-secondary">{formatInt(page)}</span> de{' '}
        <span className="tnum text-fg-secondary">{formatInt(Math.max(totalPages, 1))}</span>
      </span>

      <div className="flex items-center gap-1">
        <Button
          size="sm"
          disabled={busy || page <= 1}
          onClick={() => onPageChange(page - 1)}
          aria-label="Página anterior"
        >
          ← anterior
        </Button>
        <Button
          size="sm"
          disabled={busy || page >= totalPages}
          onClick={() => onPageChange(page + 1)}
          aria-label="Próxima página"
        >
          próxima →
        </Button>
      </div>
    </nav>
  )
}
